import { useMutation } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { ImportFileStatus } from '../../api/partner'
export interface ImportDetail {
   id: number
   externalId: number
   firstName: string | null
   lastName: string | null
   email: string | null
   message: string
}

interface ImportResult {
   errorMessage: string | null
   message: string
   result: {
      account: string
      id: number
      loyaltyPlanId: number
      path: string
      type: 'MEMBERS' | 'OPERATIONS_PMS'
      status: 'PENDING' | 'COMPLETED' | 'FAILED' | 'IN_PROGRESS'
      isViewed: boolean
      processed: number | null
      notProcessed: number | null
      errors: string[] | null
      importDetails: ImportDetail[] | null 
      errorMessage: string | null
      createdAt: string
      updatedAt: string | null
      authorEmail: string | null
      authorName: string | null
   }
}

const TERMINAL_STATUSES = ['COMPLETED', 'ERROR']

function useIsProcessingImport({ type }: { type: string }) {
   const [isProcessingImport, setIsProcessingImport] = useState(false)
   const [data, setData] = useState<ImportResult | null>(null)
   const [isMounted, setIsMounted] = useState(false)
   const [isDone, setIsDone] = useState(false)
   const [dismissedId, setDismissedId] = useState<number | null>(null)

   const { mutate: statusImport } = useMutation({
      mutationFn: ImportFileStatus,
   })

   const reset = () => {
      setDismissedId(data?.result?.id ?? null)
      setData(null)
      setIsProcessingImport(false)
      setIsMounted(false)
      setIsDone(false)
   }

   useEffect(() => {
      if (!type || isDone) return

      let intervalId: ReturnType<typeof setInterval> | null = null

      const fetchStatus = async () => {
         await statusImport(
            { type },
            {
               onSuccess: (response) => {
                  const resultId = response?.result?.id
                  const status = response?.result?.status
                  if (dismissedId !== null && resultId === dismissedId) return
                  setIsMounted(true)
                  setIsProcessingImport(true)
                  setData(response)
                  if (status && TERMINAL_STATUSES.includes(status)) {
                     setIsDone(true)
                     if (intervalId) clearInterval(intervalId)
                  }
               },
               onError: (e: any) => {
                  console.log('error', e)
               },
            },
         )
      }

      fetchStatus()
      intervalId = setInterval(fetchStatus, 1500)
      return () => {
         if (intervalId) clearInterval(intervalId)
      }
   }, [type, statusImport, isDone, dismissedId])

   return { isProcessingImport, data, isMounted, isDone, reset }
}

export default useIsProcessingImport